/* Glass skin (id `glass`; this file keeps its historical name) — liquid cursor edge-rim (§8 of the design doc).
   Writes only two CSS custom properties (--tr-rx / --tr-ry, the pointer position as a %
   of the element) so the expensive backdrop-filter layer never repaints on mouse-move —
   the brightening lives on a non-blurred overlay pseudo-element (see translucent.css).
   Gated: Glass skin only, desktop pointer only, respects reduced-motion + the
   data-tr-pointer-glow="off" knob. Touch devices get the bubble + lift (CSS :hover) only. */
(function () {
  var root = document.documentElement;
  // Device traits (fine pointer, reduced-motion) don't change when the visitor switches
  // skin, so they stay a one-time gate. The SKIN/glow check, however, must be re-evaluated
  // per event (see glassOf) — otherwise loading a non-Glass page bails here forever
  // and switching TO Glass via the skin switcher never arms the rim until a reload.
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (!fine || reduce) return;

  // every clickable glass element EXCEPT in-post body text links (§8)
  var SEL = '.gh-card, .gh-button, .gh-btn, button[type="submit"], .blog-navbar-item, ' +
            '#gh-navigation a, .breadcrumbs-container a, .gh-search, .gh-tone-toggle';
  var rafId = 0, pending = null;

  function flush() {
    rafId = 0;
    if (!pending) return;
    var el = pending.el, rect = pending.rect, x = pending.x, y = pending.y;
    el.style.setProperty('--tr-rx', ((x - rect.left) / rect.width * 100).toFixed(2) + '%');
    el.style.setProperty('--tr-ry', ((y - rect.top) / rect.height * 100).toFixed(2) + '%');
    pending = null;
  }
  // Resolve the nearest glass element for an event, excluding in-post body links/buttons.
  function glassOf(node) {
    // Re-check skin + glow knob LIVE on every event so switching to/from Translucent via
    // the skin switcher arms/disarms the rim instantly, with no page reload required.
    if (root.getAttribute('data-skin') !== 'glass') return null;
    if (root.getAttribute('data-tr-pointer-glow') === 'off') return null;
    if (!node || node.nodeType !== 1 || !node.closest) return null;
    var el = node.closest(SEL);
    if (!el || el.closest('.gh-content')) return null;
    return el;
  }
  // Event delegation on document: pointerover/out/move BUBBLE, so cards appended later by
  // preload + infinite scroll (pagination.js) and reordered by applySort are handled with no
  // re-binding. pointerenter/leave (the old approach) do NOT bubble — that one-time binding
  // missed every card not present at load. (B1 fix, Task 9.)
  function onOver(e) {
    var glass = glassOf(e.target);
    if (!glass) return;
    // already inside this glass element (moved between its children) — ignore
    if (e.relatedTarget && glass.contains(e.relatedTarget)) return;
    glass.__trRect = glass.getBoundingClientRect(); // recompute: rect changes after sort/scroll
    glass.classList.add('tr-rim-active');
  }
  function onMove(e) {
    var glass = glassOf(e.target);
    if (!glass) return;
    pending = { el: glass, rect: glass.__trRect || glass.getBoundingClientRect(), x: e.clientX, y: e.clientY };
    if (!rafId) rafId = window.requestAnimationFrame(flush);
  }
  function onOut(e) {
    var glass = glassOf(e.target);
    if (!glass) return;
    // still inside this glass element (moved to one of its children) — ignore
    if (e.relatedTarget && glass.contains(e.relatedTarget)) return;
    glass.classList.remove('tr-rim-active');
    glass.style.removeProperty('--tr-rx');
    glass.style.removeProperty('--tr-ry');
  }
  document.addEventListener('pointerover', onOver);
  document.addEventListener('pointermove', onMove);
  document.addEventListener('pointerout', onOut);
})();
